import { InputNumber } from 'antd';
const InputNumberForm = (props) => {
    let { updated, desc } = props;
    const disabled = updated !== 0;
    //最大值和最小值在外层form.item判断了
    let { setting = {} } = props,
     { number_range } = setting,
     [min, max] = number_range;
    return <InputNumber min={min} max={max} disabled={disabled} style={{ width: '100%' }} placeholder={desc}></InputNumber>;
};
export default InputNumberForm;
